/**
 * Shared UK telephone normalisation for Directory + staged contact matching.
 * Equivalent forms resolve to the same digits, e.g.
 * 07799 534934 / 07799534934 / +447799534934 → 447799534934
 */
export function digitsOnly(value?: string | null): string {
  return String(value || '').replace(/\D/g, '');
}

export function normalizeUkDigits(value?: string | null): string | null {
  let digits = digitsOnly(value);
  if (!digits) return null;
  if (digits.startsWith('00')) digits = digits.slice(2);
  if (digits.startsWith('44') && digits.length >= 11) return digits;
  if (digits.startsWith('0') && digits.length >= 10) return `44${digits.slice(1)}`;
  if (digits.length === 10 && digits.startsWith('7')) return `44${digits}`;
  return digits;
}

export function phonesEquivalent(left?: string | null, right?: string | null): boolean {
  const a = normalizeUkDigits(left);
  const b = normalizeUkDigits(right);
  return Boolean(a && b && a === b);
}

export function customerHref(name: string): string {
  return `/customers/${encodeURIComponent(name)}`;
}
